export default __webpack_public_path__ + "static/media/signature.95d709a0.png";